// Real, verified tourism case studies for Anne Flinn Advertising.
// Source: anneflinn.com/client-stories — all metrics quoted verbatim.

export const caseStudies = {
  "nelson-county-tourism": {
    slug: "nelson-county-tourism",
    client: "Nelson County Tourism",
    campaign: "Multi-State Omni-Channel Digital Campaign",
    categoryLabel: "DMO · 12-Month Campaign",
    categoryColor: "from-emerald-500/30 to-sky-500/20",
    icon: "Globe",
    image:
      "https://anneflinn.com/assets/uploads/_medium/visit-nelson-county_2025-11-11-233251_iotw.jpg",
    anchorImage: "/media/case-studies/wanderlove-mom-anchor.jpg",
    videoUrl: "/media/reel/wanderlove-case-report.mp4",
    videoPoster: "/media/reel/wanderlove-case-report.jpg",
    heroMetric: { value: "45,000+", label: "Website Visits" },
    headline:
      "How Nelson County Tourism drove 45,000+ website visits, multi-state, omni-channel.",
    summary:
      "A 12-month campaign funded by a Virginia Tourism Corporation grant. We refreshed the brand, audited every digital asset, and ran streaming, PMAX, paid social, and Social Mirror ads in sync, building the cohesive presence that made every other Nelson County campaign possible.",
    metrics: [
      { value: "45,000+", label: "Website Clicks" },
      { value: "+1,700%", label: "Facebook Reach" },
      { value: "+4,700%", label: "Instagram Reach" },
    ],
    roles: ["Advertising", "Organic Marketing", "Video Production", "Graphic Design", "SEO"],
    testimonial: {
      quote:
        "Anne Flinn Advertising consistently delivers high-quality creative products, strategic guidance, and measurable results. On a scale of 1 to 10, I would rate their performance a 10. They have helped Nelson County Tourism strengthen brand awareness, increase visitor engagement, and navigate changing tourism trends with innovative and thoughtful campaigns.",
      author: "Maureen Kelley, Director of Economic Development & Tourism, Nelson County, VA",
    },
    externalUrl: "https://anneflinn.com/client-stories/nelson-county-tourism",
    primaryCategory: "dmos",
    relevantCategories: ["dmos", "hotels-inns"],
    featured: true,
  },

  "eat-drink-love": {
    slug: "eat-drink-love",
    client: "Nelson County Tourism",
    campaign: "Eat. Drink. Love. Gamified Trail",
    categoryLabel: "DMO · Gamified Tourism Trail",
    categoryColor: "from-rose-500/30 to-amber-400/20",
    icon: "Utensils",
    image:
      "https://anneflinn.com/assets/uploads/_medium/edl_farm_final_fb_993.jpg",
    videoUrl: "/media/reel/edl-case-report.mp4",
    videoPoster: "/media/reel/edl-case-report.jpg",
    heroMetric: { value: "+110%", label: "Above Benchmark" },
    headline:
      "A gamified trail campaign that beat industry benchmarks by 110%.",
    summary:
      "We took the existing \"Eat. Drink. Love.\" branding from Virginia Tourism and turned it into an \"Eat. Drink. Love. Trail\" for Nelson County Tourism. This gamified trail experience was promoted across the Nelson 151 Corridor and brought in businesses up and down Rte. 151. The results were exceptional — so much so that the developers of the gamified app told us it was one of the best-performing programs they had seen.",
    metrics: [
      { value: "255%", label: "Engagement Score" },
      { value: "+110%", label: "Above Benchmark" },
      { value: "304", label: "Sign-Ups" },
      { value: "186", label: "Marketing Opt-Ins" },
    ],
    roles: ["Graphic Design", "Digital Ads", "Social Media Advertising"],
    testimonial: null,
    externalUrl:
      "https://anneflinn.com/client-stories/nelson-countys-eat-drink-love",
    primaryCategory: "events-festivals",
    relevantCategories: ["events-festivals", "restaurants"],
    featured: false,
  },

  "dark-skies": {
    slug: "dark-skies",
    client: "Nelson County Tourism",
    campaign: "Dark Skies Stargazing Campaign",
    categoryLabel: "DMO · Experiential Tourism · 10-Month Campaign",
    categoryColor: "from-indigo-500/30 to-purple-500/20",
    icon: "Sparkles",
    image:
      "https://anneflinn.com/assets/uploads/_medium/dark-skies.jpg",
    videoUrl: "/media/reel/dark-skies-case-report.mp4",
    videoPoster: "/media/reel/dark-skies-case-report.jpg",
    heroMetric: { value: "823,721", label: "Impressions" },
    headline:
      "823,000+ impressions for a first-of-its-kind stargazing campaign in Virginia.",
    summary:
      "We helped launch the first 'Dark Skies' campaign in the Commonwealth, a 10-month social push highlighting Nelson County's pristine night sky. 80,000 impressions per month to Northern Virginia drove stay-over traffic, and local-business partnerships created community-wide momentum.",
    metrics: [
      { value: "823,721", label: "Impressions Served" },
      { value: "7,246", label: "Total Clicks" },
      { value: "45,139", label: "Post Engagements" },
      { value: "2,238", label: "Total Conversions" },
    ],
    roles: ["Advertising", "Graphic Design"],
    testimonial: null,
    externalUrl:
      "https://anneflinn.com/client-stories/nelson-county-tourisms-dark-skies-campaign",
    primaryCategory: "attractions",
    relevantCategories: ["attractions", "dmos"],
    featured: false,
  },

  "cunningham-creek-winery": {
    slug: "cunningham-creek-winery",
    client: "Cunningham Creek Winery",
    campaign: "Year-Round Paid Social Campaign",
    categoryLabel: "Winery · Paid Social · Palmyra, VA",
    categoryColor: "from-rose-500/30 to-violet-500/20",
    icon: "Wine",
    image:
      "https://anneflinn.com/assets/uploads/_medium/ccw600music_orig.png",
    heroMetric: { value: "19,695", label: "Website Clicks" },
    headline:
      "A rural winery turned its biggest challenge into packed events every weekend.",
    summary:
      "Cunningham Creek sits off the beaten path in Palmyra, beautiful property, packed event calendar, but visitor traffic was the bottleneck. A robust Facebook + Instagram paid campaign showcased their property, wine, and events to fresh audiences. 5Ks, harvest fests, music bingo, book clubs, sold out, rain or shine.",
    metrics: [
      { value: "899,670", label: "Impressions" },
      { value: "19,695", label: "Total Clicks" },
      { value: "100,120", label: "Post Engagements" },
      { value: "3,010", label: "Conversions" },
    ],
    roles: ["Digital Ads", "Social Media Advertising"],
    testimonial: null,
    externalUrl:
      "https://anneflinn.com/client-stories/cunningham-creek-winerys-paid-social-campaign",
    primaryCategory: "wineries-breweries",
    relevantCategories: ["wineries-breweries", "events-festivals"],
    featured: false,
  },

  "young-chefs-academy": {
    slug: "young-chefs-academy",
    client: "Young Chefs Academy",
    campaign: "Charleston Open House + Enrollment Campaign",
    categoryLabel: "Culinary · Paid Social · Charleston, SC",
    categoryColor: "from-amber-400/30 to-rose-500/20",
    icon: "Utensils",
    image:
      "https://anneflinn.com/assets/uploads/_medium/young-chefs-mobile.jpg",
    heroMetric: { value: "155", label: "Event Sign-Ups" },
    headline:
      "A packed open house, six new memberships, 15 first-time attendees, from one campaign.",
    summary:
      "Young Chefs Academy needed to fill their Charleston open house AND build long-term awareness. We ran dynamic creative across Facebook News Feed, Stories, Events, Instagram Reels, and Collections, rotating messaging frequently to keep audiences fresh. They focused on the event; we handled META's ever-changing algorithms.",
    metrics: [
      { value: "14,000", label: "Engagements" },
      { value: "1,700", label: "Clicks" },
      { value: "155", label: "Event Sign-Ups" },
    ],
    roles: ["Advertising", "Graphic Design"],
    testimonial: {
      quote:
        "Since we began advertising with Anne Flinn Advertising, we've seen an incredible boost in our enrollment at Young Chefs Academy. Our workshops have been filling up, camp registrations keep rolling in, and most importantly, we're welcoming so many new faces. Anne and her team truly understand how to reach the right audience. Highly recommend!",
      author: "Nancy Whelan, Managing Director, Young Chefs Academy",
    },
    externalUrl: "https://anneflinn.com/client-stories/young-chefs-academy",
    primaryCategory: "restaurants",
    relevantCategories: ["restaurants", "events-festivals"],
    featured: false,
  },
};

export const caseStudyList = Object.values(caseStudies);

// Helper: find the best case study for a category. Prefers primaryCategory
// matches before falling back to any relevantCategories match — so adding a
// new case study cannot silently steal another category's primary slot.
export const findCaseStudyFor = (categorySlug) => {
  const primary = caseStudyList.find(
    (cs) => cs.primaryCategory === categorySlug
  );
  if (primary) return primary;
  return caseStudyList.find((cs) =>
    cs.relevantCategories?.includes(categorySlug)
  );
};
